import React, { useEffect, useState } from "react";
import AsteriskStyle from "../../Form/Tooltip/AsteriskStyle";
import CustomButton from "../../common/CustomButton";
import { getBackgroundClass, interestLevel, leadStatusList } from "../../../Enum/LeadEnumConstants";
import Select, { components } from "react-select";
import { FaChevronDown } from "react-icons/fa";
import useLeadSource from "../../../hooks/useLeadSource";
import CustomSelect from "../../common/CustomSelect";
const CustomAPIForm = ({ onClose }) => {

    const {
        sourceData,
        fetchLeadSource
    } = useLeadSource()

  
    const [selectedSources, setSelectedSources] = useState([]);
    const [selectedLeadStatus, setSelectedLeadStatus] = useState([]);
    
    useEffect(()=>{
        fetchLeadSource()
    },[])
  


  return (
    <div className="flex flex-col min-h-[710px] justify-between gap-5 p-4">
      {/* Form Inputs */}
      <div className="flex flex-col gap-5">
        <div className="grid grid-cols-12 items-center">
          <label className="col-span-4 text-sm font-medium text-gray-700">
            Platform Name
            <AsteriskStyle />
          </label>
          <div className="col-span-8">
            <input
              type="text"
              name="unitNo"
              maxLength={5}
              className="w-full px-3 py-2 border border-gray-300 rounded-md input-focus"
              placeholder="Platform Name"
            />
          </div>
        </div>

        <div className="grid grid-cols-12 items-center">
          <label className="col-span-4 text-sm font-medium text-gray-700">
            Lead Source
            <AsteriskStyle />
          </label>
          <div className="col-span-8">
          <CustomSelect
 
  options={sourceData}
  value={selectedSources}
  onChange={(selected) => setSelectedSources(selected)}
  placeholder="Select Lead Source(s)"
/>


          </div>
        </div>
        

        <div className="grid grid-cols-12 items-center">
          <label className="col-span-4 text-sm font-medium text-gray-700">
            Lead Quality
            <AsteriskStyle />
          </label>
          <div className="col-span-8">
          <CustomSelect
  options={interestLevel}
  placeholder="Select Lead Quality"
  value={selectedLeadStatus}
  onChange={
    (selected) => setSelectedLeadStatus(selected)
  }
/>
          </div>
        </div>

        <div className="grid grid-cols-12 items-">
          <label className="col-span-4 text-sm font-medium text-gray-700">
            Lead Description
            <AsteriskStyle />
          </label>
          <div className="col-span-8">
            <textarea
              className="w-full px-3 py-2 border border-gray-300 h-[200px] rounded-md input-focus"
              placeholder="Enter Description"
            />
          </div>
        </div>
      </div>

      {/* Button at Bottom */}
      <div className="mt-auto pt-4">
        <CustomButton label={"Create"} className={"w-full justify-center"} />
      </div>
    </div>
  );
};

export default CustomAPIForm;
